import {connect} from 'react-redux';
import {GelResults as Component} from './GelResults';
import {} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  return {
    gelDragDropPrediction: state.notebook.protocolSection.scene.gelDragDropPrediction,
    interactionProps: {
      solutions: state.notebook.protocolSection.scene.apparatus.solutions
    },
    prepareGelBox: state.notebook.protocolSection.prepareGelBox,
    runGel: state.notebook.protocolSection.runGel,
    visualizeGel: state.notebook.protocolSection.visualizeGel,
    loadDNALadder: state.notebook.protocolSection.loadDNALadder,

  }

}

function mapDispatchToProps(dispatch) {
  return {};
}

export const GelResults = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
